<template>
  <div class="stress-management">
    <div class="d-flex justify-space-between">
      <h2 class="mb-8">{{ $ucfirst($t("screens.smokeFreeLivingSettingsScreen", { catalog: 'app_mobile' })) }}</h2>
      <level-of-guidance-indicator behaviourComponent="SMOKECESSATION"></level-of-guidance-indicator>
    </div>
    <smoking-button-line />
    <router-view></router-view>
    <discussion-step-nav-buttons
        :nextRoutes="nextDiscussionStep"
        :prevRoutes="prevDiscussionStep"
    >
    </discussion-step-nav-buttons>
  </div>
</template>

<script>
import DiscussionStepNavButtons from '../../../components/Parts/DiscussionStepNavButtons.vue';
import LevelOfGuidanceIndicator from "../../../components/Parts/LevelOfGuidanceIndicator.vue";
import SmokingButtonLine from "dashboard/templates/components/Parts/SmokingButtonLine.vue";

export default {
  name: 'PatientOverviewSmoking',
  props: ['nextDiscussionStep', 'prevDiscussionStep'],
  components: {
    SmokingButtonLine,
    LevelOfGuidanceIndicator,
    DiscussionStepNavButtons
  }
}
</script>
